import { LayerProps } from 'utils/types';

export const dataLayer: LayerProps = {
  id: 'states',
  type: 'fill',
  paint: {
    'fill-color': {
      property: 'density',
      stops: [
        [25, '#0d41e1'],
        [50, '#0c63e7'],
        [75, '#0a85ed'],
        [100, '#09a6f3'],
        [125, '#07c8f9']
      ]
    },
    'fill-opacity': 0.7
  }
};
